import { useQuery } from '@tanstack/react-query';
import { fetchPorts, type Port } from '@/services/map/layers/portsLayer';

/**
 * React Query hook for fetching ports
 * Ports are global data, so we fetch them as soon as getToken is available
 * polygonWkt is kept in the query key for cache invalidation purposes
 */
export const usePolygonPorts = (getToken: (() => Promise<string>) | undefined, _polygonWkt: string | null) => {
  return useQuery<Port[], Error>({
    queryKey: ['ports'],
    enabled: !!getToken,
    queryFn: async () => {
      if (!getToken) {
        throw new Error('getToken is required to fetch ports');
      }
      return fetchPorts(getToken);
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - ports are relatively static
  });
};
